import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import global_en from './translation/en/global.json';
import global_he from './translation/he/global.json';
import i18next from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { applyDocumentLanguage, readStoredLanguage } from './i18n/useLang';

const initialLanguage = readStoredLanguage();

i18next.init({
  interpolation: { escapeValue: false },
  lng: initialLanguage,
  fallbackLng: 'en',
  resources: {
    en: { global: global_en },
    he: { global: global_he },
  },
});

applyDocumentLanguage(initialLanguage);
i18next.on('languageChanged', applyDocumentLanguage);

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
